import React from 'react';
import {Card, Col} from 'react-bootstrap';

import './offlinesteps.css';

class OfflineSteps extends React.Component {
  constructor(props) {
    super(props)

    console.log(props)

    this.state = {
      bill: props.bill,
      visibility: props.visibility,
    }
  }

  render() {
    let offlineStepsCss = {}

    if (this.state.visibility.highlight_last_step === true) {
      offlineStepsCss = { marginTop: "20px", overflowY: 'scroll' };
    }

    return (
      <Col md={7}>
        {this.state.visibility.highlight_last_step === true && (
          <Card>
            <Card.Body style={{ paddingTop: "1.9rem", paddingBottom: 0, paddingRight: "1.25rem"}}>
              <Card.Title>
                Último andamento
              </Card.Title>

              <p style={{fontSize: "18px", paddingLeft: "20px", fontWeight: "500"}}>{ this.state.bill.last_step.content.replace(/<\/?[^>]+(>|$)/g, '') }</p>
            </Card.Body>
          </Card>
        )}

        {this.state.visibility.offline_steps === true && (
          <Card style={offlineStepsCss}>
            <Card.Body style={{ maxHeight: '500px', overflowY: 'auto' }}>
              <Card.Title>
                Andamentos
              </Card.Title>

              <div className="vertical-time-simple vertical-without-time vertical-timeline vertical-timeline--animate vertical-timeline--one-column">

                {
                  this.state.bill.offline_steps.map((step, index) => {
                    return (
                      <div className="vertical-timeline-item vertical-timeline-element">
                        <div>
                          <span className="vertical-timeline-element-icon bounce-in" />
                        </div>
                        <div className="vertical-timeline-element-content bounce-in">
                          <h4 style={{fontSize: "17px", fontWeight: "500"}} className="text-left">{step[1]} {step[0]}</h4>
                          <h5 className="timeline-title">
                            {step[2]}
                          </h5>
                          <span className="vertical-timeline-element-date"></span>
                        </div>
                      </div>
                    );
                  })
                }
              </div>
            </Card.Body>
          </Card>
        )}
      </Col>
    );
  }
}

export default OfflineSteps;
